import React from 'react';

import { Switch, Route } from 'react-router-dom';

import Home from '../pages/home';
import FleetOwner from '../pages/fleetOwner';

const Routes = () => (
  <Switch>
    <Route exact path="/" component={Home} />
    <Route path="/frotista" component={FleetOwner} />
  </Switch>
);

export default Routes;
